import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    has_more: false,
    influencers: null,
    influencer: null,
    vello_subscription: null,
    vip_subscription: null,
    default_currency: null,
  },

  mutations: {
    setInfluencers(state, data) {
      if (!state.influencers) {
        state.influencers = data.influencers
      } else {
        state.influencers = state.influencers.concat(data.influencers)
      }

      state.has_more = !!data.next_page_url
    },

    setSubscription(state, data) {
      state.influencer = data.influencer
      state.vello_subscription = data.vello_subscription
      state.vip_subscription = data.vip_subscription
      state.default_currency = data.default_currency
    },

    clearInfluencers(state) {
      state.influencers = null
    },

    clearSubscription(state) {
      state.influencer = null
      state.vello_subscription = null
      state.vip_subscription = null
      state.default_currency = null
    },
  },

  actions: {
    // returns list of influencers the user is subscribed
    async getInfluencers({ commit }, params) {
      await Api.get(
        `subscriptions/influencers?limit=${params.limit}&page=${params.page}&search=${params.search}`
      ).then(({ data }) => {
        commit('setInfluencers', data.data)
      })
    },

    // return list of subscriptions from a specific Influencer
    async getInfluencerSubscriptions({ commit }, influencerUID) {
      await Api.get(`subscriptions/influencer/${influencerUID}`).then(
        ({ data }) => {
          commit('setSubscription', data.data)
        }
      )
    },
  },
}
